module.exports = __webpack_public_path__ + "static/media/cloud-showers.38c5341d.svg";